import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MobileFooter.css';

const MobileFooter = ({ companyInfo = {} }) => {
    const { isAuthenticated } = useAuth();

    return (
        <footer className="mobile-footer">
            <div className="mobile-footer-content">
                {/* Logo and Company Name */}
                <div className="mobile-footer-brand">
                    <img src="/images/logo.png" alt="Logo" className="mobile-footer-logo" />
                    <span className="mobile-footer-company-name">
                        {companyInfo.name || companyInfo.shortName || '留洋教育科技公司'}
                    </span>
                </div>

                {/* Contact Information */}
                <div className="mobile-footer-contact">
                    <p className="mobile-footer-contact-line">
                        {companyInfo.chinaCustomerServiceNo || '—'} (中國) | {companyInfo.hkCustomerServiceNo || '—'} (中國香港)
                    </p>
                    <p className="mobile-footer-contact-line">
                        服務郵箱: {companyInfo.email1 || '—'}
                    </p>
                </div>

                {/* Copyright and Website */}
                <div className="mobile-footer-copyright">
                    <p className="mobile-footer-copyright-line">
                        Copyright {new Date().getFullYear()} &copy; {companyInfo.shortName || '留洋'} Education Technology.
                    </p>
                    {companyInfo.website && (
                        <p className="mobile-footer-copyright-line">
                            網站: <a href={companyInfo.website} target="_blank" rel="noopener noreferrer" className="mobile-footer-link">
                                {companyInfo.website}
                            </a>
                        </p>
                    )}
                    <p className="mobile-footer-copyright-line mobile-footer-disclaimer">
                        平台內部分圖片素材由AI生成
                    </p>
                </div>

                {/* Admin Login - only show when not authenticated */}
                {!isAuthenticated && (
                    <div className="mobile-footer-admin">
                        <Link to="/login" className="mobile-footer-admin-link">
                            管理員登入
                        </Link>
                    </div>
                )}
            </div>
        </footer>
    );
};

export default MobileFooter;

